import { render, staticRenderFns } from "./pricelisthelp.vue?vue&type=template&id=07560e24&"
import script from "./pricelisthelp.vue?vue&type=script&lang=js&"
export * from "./pricelisthelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07560e24')) {
      api.createRecord('07560e24', component.options)
    } else {
      api.reload('07560e24', component.options)
    }
    module.hot.accept("./pricelisthelp.vue?vue&type=template&id=07560e24&", function () {
      api.rerender('07560e24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Z2F5L93I5LCO/JS/pricelisthelp.vue"
export default component.exports